export interface NoiseCell {
  level: string | null;
  updated_at: string | null;
}

export interface NoiseMatrix {
  weekday: { morning: NoiseCell; afternoon: NoiseCell; evening: NoiseCell };
  weekend: { morning: NoiseCell; afternoon: NoiseCell; evening: NoiseCell };
}

const NOISE_LABELS: Record<string, string> = {
  quiet: 'Quiet',
  moderate: 'Moderate',
  lively: 'Lively',
};

type TimeOfDay = 'morning' | 'afternoon' | 'evening';

function getTimeOfDay(hour: number): TimeOfDay {
  if (hour >= 6 && hour <= 10) return 'morning';
  if (hour >= 11 && hour <= 15) return 'afternoon';
  return 'evening';
}

function getDayType(day: number): 'weekday' | 'weekend' {
  return day === 0 || day === 6 ? 'weekend' : 'weekday';
}

/**
 * Resolve the current noise level from a noise_matrix based on local time.
 * Returns { level, label } or null if no data for the current slot.
 */
export function getCurrentNoise(matrix: NoiseMatrix | null | undefined): { level: string; label: string } | null {
  if (!matrix) return null;

  const now = new Date();
  const dayType = getDayType(now.getDay());
  const timeOfDay = getTimeOfDay(now.getHours());

  const cell = matrix[dayType]?.[timeOfDay];
  if (!cell?.level) return null;

  return {
    level: cell.level,
    label: NOISE_LABELS[cell.level] || cell.level,
  };
}
